import { createTheme, responsiveFontSizes } from "@mui/material";
import baseTheme from "./base-theme.tsx";

const DefaultTheme = createTheme({
    ...baseTheme,
    palette: {
        mode: "dark",
        primary: {
            main: "#465FC6",
            light: "#8CA7F2",
        },
        secondary: {
            main: "#282D30",
            light: "#DDDDDD",
        },
        background: {
            default: "#22272C",
        },
    },
    components: {
        ...baseTheme.components,
        MuiButton: {
            styleOverrides: {
                ...baseTheme.components?.MuiButton?.styleOverrides,
                containedSecondary: {
                    backgroundColor: "#674A9E",
                    textTransform: "none",
                    "&:hover": {
                        backgroundColor: "#564289",
                    },
                },
                containedPrimary: {
                    color: "#ffffff",

                    "&:hover": {
                        backgroundColor: "#3855B2",
                    },
                },
            },
        },

        MuiCssBaseline: {
            styleOverrides: {
                a: {
                    color: "#8CA7F2", // primary.light
                    textDecoration: "none",
                    transition: "color 0.2s ease-in-out, opacity 0.2s ease-in-out",
                    "&:hover": {
                        color: "#465FC6", // primary.main
                        textDecoration: "underline",
                    },
                },
            },
        },

        MuiInputLabel: {
            styleOverrides: {
                root: {
                    "&.Mui-focused": {
                        color: "#8CA7F2", // primary.light color for the focused state
                    },
                },
            },
        },
    },
});

export default responsiveFontSizes(DefaultTheme);
